
import * as d3 from 'd3'
export default {
  methods: {

    draw_Contents() {
      let viewbox = this.scroll.viewbox
      
      this.canvasContents = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .attr('font-family', 'roboto')

      this.canvasContents
      .append('defs')
      .append('clipPath')
      .attr('id', `CLIP_AREA_${this.localId}`)
      .append('rect')
      .attr('x', viewbox.x).attr('y', viewbox.y)
      .attr('width', viewbox.width).attr('height', viewbox.height)

      let clippedGroup = this.canvasContents
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .attr('clip-path', `url(#CLIP_AREA_${this.localId})`)

      // clippedGroup // Stroke for temporary
      // .append('rect')
      // .attr('x', viewbox.x).attr('y', viewbox.y).attr('stroke', '#757575').attr('stroke-width', 0.5)
      // .attr('width', viewbox.width).attr('height', viewbox.height).attr('fill', 'none')
      


      // CONTENTS fro Scroll ----------------------------------------------------------------------------------------------
      let dataGroup = clippedGroup
      .append('g')
      .attr('id', `CONTENTS_${this.localId}`)
      .attr('transform', `translate(${this.table.x}, ${this.scroll.viewbox.y})`)
      
      let y_ = 12
      this.filterData.forEach(d=> {

        let row = dataGroup
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .attr('cursor', 'pointer')
        .call(this.call_ErectionBlock, d)

        row
        .append('rect')
        .attr('id', `ROW_${d.SN}_${this.localId}`)
        .attr('x', 5).attr('y', -9)
        .attr('width', this.table.width).attr('height', 18)
        .attr('fill', '#bcbcbc').attr('opacity', 0)

        this.columns.forEach(col=> {
          row
          .append('text')
          .attr('class', `ROWS ROW_${d.SN}_${this.localId}`)
          .attr('transform', `translate(${col.mx}, ${10*0.35})`)
          .attr('font-size', 10).attr('fill', this.current.idx == d.SN ? '#EC407A' : '#757575')
          .attr('text-anchor', col.align)
          .text(d[col.code])
        })
        y_ += 20
      })

      this.scroll.content.height = y_ - 10
      this.set_ScrollValues()
    },

  }
}